import { render } from "./not-found-scr.vue?vue&type=template&id=6e2dd688&scoped=true"
import script from "./not-found-scr.vue?vue&type=script&lang=js"
export * from "./not-found-scr.vue?vue&type=script&lang=js"

import "./not-found-scr.vue?vue&type=style&index=0&id=6e2dd688&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2dd688"]])

export default __exports__